import { all, call, spawn } from 'redux-saga/effects';

import { authSaga } from '../features/auth/authSaga';
import { requestSaga } from '../features/request/requestSaga';

export const rootSaga = function* rootSaga() {
    const sagas = [authSaga, requestSaga];

    yield all(
        sagas.map((saga) =>
            spawn(function* sagaTask() {
                while (true) {
                    try {
                        yield call(saga);
                        break;
                    } catch (e) {
                        window.console.error(e);
                    }
                }
            }),
        ),
    );
};
